import { useState, useEffect } from 'react';
import { apis, apiHolder } from 'api';
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const useFeatureVisibility = (key) => {
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            return;
        }
        try {
            const forbiddenDomainsStr = productAuthApi.getABSwitchSync(key);
            if (!forbiddenDomainsStr) {
                return;
            }
            const forbiddenDomains = JSON.parse(forbiddenDomainsStr);
            if (!Array.isArray(forbiddenDomains) || !forbiddenDomains.length) {
                return;
            }
            const userInfo = systemApi.getCurrentUser();
            const isForbidden = forbiddenDomains.some(domain => { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) === null || _a === void 0 ? void 0 : _a.endsWith(domain); });
            if (isForbidden) {
                setIsVisible(false);
            }
        }
        catch (error) {
            console.log(`Failed to check visibility for key ${key}:`, error);
        }
    }, [key]);
    return isVisible;
};
export default useFeatureVisibility;
